import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { Content } from 'core/layouts';
import { BasicCheckbox } from 'core/components';
import { observer } from 'mobx-react';
function FacilityOrderTemplateNewFlowInsuranceHistoryOfChangesModalTemplate({ facilityOrderTemplateNewFlowInsuranceHistoryOfChangesModalStore }) {
    const {
        contentLoading,
        patient,
        facilityOrderTemplates,
        facilityOrderPatient,
        isPrimaryInsuranceDifferent,
        isInactivePrimaryInsuranceDifferent,
        isSecondaryInsuranceDifferent,
        isInactiveSecondaryInsuranceDifferent,
        isEligibilityStatusDifferent,
    } = facilityOrderTemplateNewFlowInsuranceHistoryOfChangesModalStore;

    return (
        <section>
            <div className="modal__header">
                <h3 className='modal__header__title u-mar--bottom--sml--alt'>Change History</h3>
            </div>
            <div className="modal__body">
                <Content loading={contentLoading} >
                    {facilityOrderPatient.note && 
                        <div className={`message message--med message--orange u-mar--bottom--sml u-mar--top--sml`}>
                            {facilityOrderPatient.note}
                        </div>
                    }
                    <div className='row'>
                        <div className="col col-sml-6 col--stretch u-mar--bottom--sml--alt">
                            <div className='card--tertiary u-flex--grow--1 u-flex--column'>

                                <div className="card--tertiary__header card--tertiary__header--popup no-gap">

                                    <div className="u-flex--default">
                                        <h4 className="card--tertiary__header__title">
                                            {patient && patient.lastName && `${patient.lastName}`}
                                            {patient && patient.lastName && patient.firstName && ', '}
                                            {patient && patient.firstName && `${patient.firstName}`}
                                        </h4>
                         
                                    </div>
                                </div>
                                <div className="card--tertiary__subheader">
                                    <div className="card--tertiary__flex">
                                    <div style={isEligibilityStatusDifferent ? { backgroundColor: "#f6ede2", color: "#0d131b", cursor: "default"  } : {}} className="is-nonclickable btn btn--base-plus btn--light btn--uppercase">{facilityOrderPatient && facilityOrderPatient.facilityOrderPatientInitial && facilityOrderPatient.facilityOrderPatientInitial.eligibilityStatus ? facilityOrderPatient.facilityOrderPatientInitial.eligibilityStatus.name : "Blank"}</div>
                                    <div>
                                        {
                                            <div className="card--tertiary__data type--tny-lh">
                                                <div>
                                                    <div className="card--tertiary__data__item has-marker" style={isPrimaryInsuranceDifferent ? { backgroundColor: "#f6ede2" } : {}}>
                                                        <div>Primary:</div>

                                                        <div className="type--color--primary type--wgt--semibold type--sml">{facilityOrderTemplates[0].facilityOrderTemplateInitial && facilityOrderTemplates[0].facilityOrderTemplateInitial.primaryInsurance}</div>

                                                        {facilityOrderTemplates[0].facilityOrderTemplateInitial && facilityOrderTemplates[0].facilityOrderTemplateInitial.primaryPolicyNo &&
                                                            <div>{facilityOrderTemplates[0].facilityOrderTemplateInitial.primaryPolicyNo}</div>
                                                        }
                                                    </div>
                                                    {facilityOrderTemplates[0].facilityOrderTemplateInitial && facilityOrderTemplates[0].facilityOrderTemplateInitial.primaryInsurance !== "Medicare" && facilityOrderTemplates[0].facilityOrderTemplateInitial.inactivePrimaryPolicyNo &&
                                                        <div className="card--tertiary__data__item" style={isInactivePrimaryInsuranceDifferent ? { backgroundColor: "#f6ede2" } : {}}>
                                                            <div>Inactive:</div>
                                                            <div className="type--color--primary type--wgt--semibold type--sml">Medicare</div>
                                                            <div>{facilityOrderTemplates[0].facilityOrderTemplateInitial.inactivePrimaryPolicyNo}</div>

                                                        </div>
                                                    }
                                                </div>
                                                <div>
                                                    <div className="card--tertiary__data__item has-marker" style={isSecondaryInsuranceDifferent ? {} : {}}>
                                                        <div>Secondary:</div>
                                                        <div className="type--color--primary type--wgt--semibold type--sml">{facilityOrderTemplates[0].facilityOrderTemplateInitial && facilityOrderTemplates[0].facilityOrderTemplateInitial.secondaryInsurance}</div>
                                                        {facilityOrderTemplates[0].facilityOrderTemplateInitial && facilityOrderTemplates[0].facilityOrderTemplateInitial.secondaryPolicyNo &&
                                                            <div>{facilityOrderTemplates[0].facilityOrderTemplateInitial && facilityOrderTemplates[0].facilityOrderTemplateInitial.secondaryPolicyNo}</div>
                                                        }
                                                    </div>
                                                    {facilityOrderTemplates[0].facilityOrderTemplateInitial && facilityOrderTemplates[0].facilityOrderTemplateInitial.secondaryInsurance && !facilityOrderTemplates[0].facilityOrderTemplateInitial.secondaryInsurance.includes("Medicaid") && facilityOrderTemplates[0].facilityOrderTemplateInitial.inactiveSecondaryPolicyNo && 
                                                            <div className="card--tertiary__data__item" style={isInactiveSecondaryInsuranceDifferent ? { backgroundColor: "#f6ede2" } : {}}>
                                                            <div>Inactive:</div>
                                                            <div className="type--color--primary type--wgt--semibold type--sml">Medicaid</div>
                                                            <div>{facilityOrderTemplates[0].facilityOrderTemplateInitial.inactiveSecondaryPolicyNo}</div>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                                </div>
                                <div className="card--tertiary__body u-flex--grow--1">
                                    {facilityOrderTemplates.map(item => {
                                        return (<FacilityOrderTemplateTable key={item.id} facilityOrderTemplateNewFlowInsuranceHistoryOfChangesModalStore={facilityOrderTemplateNewFlowInsuranceHistoryOfChangesModalStore} facilityOrderTemplate={item} isInitial={true} />);
                                    })}

                                </div>
                            </div>
                        </div>
                        <div className="col col-sml-6 col--stretch u-mar--bottom--sml--alt">
                            <div className='card--tertiary u-flex--grow--1 u-flex--column'>

                                <div className="card--tertiary__header card--tertiary__header--popup no-gap">

                                    <div className="u-flex--default">
                                        <h4 className="card--tertiary__header__title">
                                            {patient && patient.lastName && `${patient.lastName}`}
                                            {patient && patient.lastName && patient.firstName && ', '}
                                            {patient && patient.firstName && `${patient.firstName}`}
                                        </h4>
                                    </div>
                                </div>
                                <div className="card--tertiary__subheader">
                                <div className="card--tertiary__flex">
                                    <div  style={isEligibilityStatusDifferent ? { backgroundColor: "#e7f2ea", color: "#0d131b", cursor: "default" } : {}} className="is-nonclickable btn btn--base-plus btn--light btn--uppercase">{facilityOrderPatient && facilityOrderPatient.eligibilityStatus ? facilityOrderPatient.eligibilityStatus.name : "Blank"}</div>
                                
                                    <div>
                                        {patient &&
                                            <div className="card--tertiary__data type--tny-lh">
                                                <div>
                                                    <div className="card--tertiary__data__item has-marker" style={isPrimaryInsuranceDifferent ? { backgroundColor: "#e7f2ea" } : {}}>
                                                        <div>Primary:</div>
                                                        <div className="type--color--primary type--wgt--semibold type--sml">{patient.primaryInsurance}</div>
                                                        {patient.primaryPolicyNo &&
                                                            <div>{patient.primaryPolicyNo}</div>
                                                        }
                                                    </div>
                                                    {patient.primaryInsurance !== "Medicare" && patient.inactiveMedicareNo &&
                                                        <div className="card--tertiary__data__item" style={isInactivePrimaryInsuranceDifferent ? { backgroundColor: "#e7f2ea" } : {}}>
                                                            <div>Inactive:</div>
                                                            <div className="type--color--primary type--wgt--semibold type--sml">Medicare</div>
                                                            <div>{patient.inactiveMedicareNo}</div>

                                                        </div>
                                                    }
                                                </div>

                                                <div>
                                                    <div className="card--tertiary__data__item has-marker"  style={isSecondaryInsuranceDifferent ? { backgroundColor: "#e7f2ea" } : {}}>
                                                        <div>Secondary:</div>
                                                        <div className="type--color--primary type--wgt--semibold type--sml">{patient.secondaryInsurance}</div>
                                                        {patient.secondaryPolicyNo &&
                                                            <div>{patient.secondaryPolicyNo}</div>
                                                        }
                                                    </div>
                                                    {!patient.secondaryInsurance.includes("Medicaid") && patient.inactiveMedicaidNo &&
                                                        <div className="card--tertiary__data__item" style={isInactiveSecondaryInsuranceDifferent ? { backgroundColor: "#e7f2ea" } : {}}>
                                                            <div>Inactive:</div>
                                                            <div className="type--color--primary type--wgt--semibold type--sml">Medicaid</div>
                                                            <div>{patient.inactiveMedicaidNo}</div>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                                </div>
                                <div className="card--tertiary__body u-flex--grow--1">
                                    {facilityOrderTemplates.map(item => {
                                        return (<FacilityOrderTemplateTable key={item.id} facilityOrderTemplateNewFlowInsuranceHistoryOfChangesModalStore={facilityOrderTemplateNewFlowInsuranceHistoryOfChangesModalStore} facilityOrderTemplate={item} isInitial={false} />);
                                    })}

                                </div>
                            </div>
                        </div>
                    </div>
                </Content>
            </div>
        </section >
    )
}

const FacilityOrderTemplateTable = observer(({ facilityOrderTemplateNewFlowInsuranceHistoryOfChangesModalStore, facilityOrderTemplate, isInitial }) => {
    const {
        changeItemsVisibility
    } = facilityOrderTemplateNewFlowInsuranceHistoryOfChangesModalStore;

    return (
        <div className="table--secondary__popup-wrapper u-mar--bottom--sml--condition">
            <table width="100%" className="table--secondary no-radius">
                <colgroup>
                    <col width="250*" />
                    <col width="250*" />
                    <col width="250*" />
                </colgroup>
                <thead>
                    <tr>
                        <th colSpan={"3"}>
                            <div className="u-flex--space-between">
                                <label>{facilityOrderTemplate.subCategory.name.toUpperCase()}</label>
                                <div className='u-flex--default u-cursor--default'>
                                    <BasicCheckbox id={facilityOrderTemplate.id} label='Prior Auth Needed' checked={isInitial ? ( facilityOrderTemplate.facilityOrderTemplateInitial && facilityOrderTemplate.facilityOrderTemplateInitial.isPriorAuthNeeded) : facilityOrderTemplate.isPriorAuthNeeded} onChange={() => { }} />
                                    <div className="u-flex u-flex--default" style={{ cursor: "pointer" }} onClick={() => { changeItemsVisibility(facilityOrderTemplate, isInitial) }}>
                                        <i className={"u-icon u-icon--xsml " + ((isInitial ? facilityOrderTemplate.itemsVisibleInitial : facilityOrderTemplate.itemsVisible) ? "u-icon--arrow-up" : "u-icon--arrow-down") + " u-mar--left--sml"} />
                                    </div>
                                </div>
                            </div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {(isInitial ? facilityOrderTemplate.itemsVisibleInitial : facilityOrderTemplate.itemsVisible) &&
                        <tr>
                            <td><span className="type--sml type--wgt--bold type--color--primary">ITEM NAME</span></td>
                            <td><span className="type--sml type--wgt--bold type--color--primary">ITEM ID</span></td>
                            <td><span className="type--sml type--wgt--bold type--color--primary">PROCEDURE CODE</span></td>
                        </tr>
                    }
                    {(isInitial ? facilityOrderTemplate.itemsVisibleInitial : facilityOrderTemplate.itemsVisible) && facilityOrderTemplate.facilityOrderTemplateItems.map((item) => {
                        return (
                            <tr key={item.id} >
                                <td>
                                    {item.product && item.product.description}
                                </td>
                                <td>
                                    {item.product && item.product.itemId}
                                </td>
                                <td>
                                    {item.product && item.product.procedureCode}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
});

FacilityOrderTemplateTable.propTypes = {
    facilityOrderTemplateNewFlowInsuranceHistoryOfChangesModalStore: PropTypes.object,
    facilityOrderTemplate: PropTypes.object.isRequired
};

FacilityOrderTemplateNewFlowInsuranceHistoryOfChangesModalTemplate.propTypes = {
    facilityOrderTemplateNewFlowInsuranceHistoryOfChangesModalStore: PropTypes.object
};

export default defaultTemplate(FacilityOrderTemplateNewFlowInsuranceHistoryOfChangesModalTemplate);
